export default "__VITE_ASSET__7f5036f6__"